<template>
  <v-select
    color="primary"
    :items="options"
    :class="[dirtyClass, 'fill-height']"
    :model-value="select"
    @update:model-value="(e) => updateValue(e)"
    item-title="display_name"
    item-value="value"
    hide-details
    persistent-hint
    variant="plain"
    density="compact"
    :readonly="!editable"
    :menu-icon="!editable ? '' : undefined"
  />
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  parameter: {
    type: String,
    required: true
  },
  options: {
    type: Array,
    required: true
  },
  editable: {
    type: Boolean,
    required: false,
    default: true
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  dirtyClass: {
    type: String,
    required: false
  }
})
const emit = defineEmits(['update', 'set'])

const select = computed(() => props.item[props.parameter])

const updateValue = (value) => {
  emit('update')
  emit('set', {
    item: props.item,
    value: value,
    parameter: props.parameter
  })
}
</script>
<style scoped>
:deep(.v-select__selection) {
  font-size: 14px;
}
</style>
